var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cf-node-properties__routing-filter row" }, [
    _c(
      "div",
      {
        key: "filter",
        staticClass: "cf-node-properties__field col-sm-6 m-b-0"
      },
      [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("SPLIT_TEST_LINK_SETTING_FILTER")) +
              "\n      "
          ),
          _c("span", [_vm._v("*")]),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.top",
                value: _vm.$t("SPLIT_TEST_LINK_SETTINGSPLIT_TEST_FILTER_TT"),
                expression: "$t('SPLIT_TEST_LINK_SETTINGSPLIT_TEST_FILTER_TT')",
                modifiers: { top: true }
              }
            ],
            staticClass: "fa fa-question-circle m-l-5",
            attrs: { "aria-hidden": "true" }
          })
        ]),
        _vm._v(" "),
        _c("InputText", {
          attrs: { required: true },
          on: { input: _vm.inputChange },
          model: {
            value: _vm.route.filter,
            callback: function($$v) {
              _vm.$set(_vm.route, "filter", $$v)
            },
            expression: "route.filter"
          }
        }),
        _vm._v(" "),
        _vm.route.filter == null || _vm.route.filter == ""
          ? _c(
              "div",
              { staticClass: "cf-node-properties__input-error p-r-15" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("ERROR_MUST_HAVE_VALUE")) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: "weight",
        staticClass: "cf-node-properties__field col-sm-6 m-b-0"
      },
      [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("SPLIT_TEST_LINK_SETTING_WEIGHT")) +
              "\n      "
          ),
          _c("span", [_vm._v("*")]),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.top",
                value: _vm.$t("SPLIT_TEST_LINK_SETTING_WEIGHT_TT"),
                expression: "$t('SPLIT_TEST_LINK_SETTING_WEIGHT_TT')",
                modifiers: { top: true }
              }
            ],
            staticClass: "fa fa-question-circle m-l-5",
            attrs: { "aria-hidden": "true" }
          })
        ]),
        _vm._v(" "),
        _c("InputNumber", {
          attrs: { required: true },
          on: { input: _vm.inputChange },
          model: {
            value: _vm.route.weight,
            callback: function($$v) {
              _vm.$set(_vm.route, "weight", $$v)
            },
            expression: "route.weight"
          }
        }),
        _vm._v(" "),
        _vm.route.weight <= 0 || _vm.route.weight > 999
          ? _c(
              "div",
              { staticClass: "cf-node-properties__input-error p-r-15" },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("ERROR_OUT_OF_RANGE")) + "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }